import { getRoundedValue } from '../../../../../../ResourceAllocationOverview/resource-allocation.formatters';
import { StyledStatItem } from '../Tooltip.style';

const StatItem = ({ value, text }) => (
  <StyledStatItem>
    <span className='value'>{getRoundedValue(value)}</span> {text}
  </StyledStatItem>
);

export default StatItem;
